import MyInfo from "../components/mypage/MyInfo";

const MyPage = () => {
  return <MyInfo />;
};
export default MyPage;
